import { Component, ComponentFactoryResolver, EventEmitter, OnInit, Output, ViewChild, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { DatatableComponent, ColumnMode } from '@swimlane/ngx-datatable';
import { ApiService } from 'app/shared/services/api.service';
import { environment } from 'environments/environment';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import swal from 'sweetalert2';
import { LmsContentEditorComponent } from '../lms-content-editor/lms-content-editor.component';
import { DynamicDetailComponent } from '../../dynamic-detail/dynamic-detail.component';
import { Subscription } from 'rxjs';
import { Store } from '@ngrx/store';
import { AppState } from 'app/App Store/state';
import { setPageNumber } from 'app/App Store/actions/pageChange.actions';
@Component({
  selector: 'app-lms-list',
  templateUrl: './lms-list.component.html',
  styleUrls: ['./lms-list.component.scss',
  "../../../../../../assets/sass/libs/datatables.scss",],
encapsulation: ViewEncapsulation.None,
})
export class LmsListComponent implements OnInit {
    @ViewChild(DatatableComponent) table: DatatableComponent;
    page = {
      pageNumber:0,
      offset: 0,
      pageSize: 10,
      totalPages:0
    };
    // row data
    public rows = [];
    public filterRows=[];
    public ColumnMode = ColumnMode;
    public limitRef = 10;
    selectedValue=''
    isFilter:boolean=false
    public columns = [
      { name: "Name", prop: "name" },
      { name: "Url Link",prop:"url_link"},
      { name: "Type", prop: "type" },
      { name: "Actions", prop: "Actions" },
    ];
  
    // private
    private tempData = []; 
  
    imageUrl=environment.apiUrls.imageUrl;
    
  
    app_id:any
    searchVal:any;
    @ViewChild('name') inputName
    user_role:any
    activeTab:any
    selectedApp:any
    appType:any
    @Output() refreshData = new EventEmitter<any>();
    @ViewChild('modalRef') modal: LmsContentEditorComponent;

    connected_courses=[]
    guideline_data:any
    pageNumberSubscription : Subscription
    pageNo
    status_list=[]
    selected_status:any=[]
    tag_cat_list =[]
    selected_tag_cat_id = null
    courses=[]
    selected_course_id = null
    constructor( public apiService:ApiService,
                 private modalService: NgbModal,private route:Router,
                 public toastr: ToastrService, private activatedRoute: ActivatedRoute,
                 private spinner: NgxSpinnerService,private resolver: ComponentFactoryResolver,
                 private store: Store<AppState>) {

                  this.user_role=JSON.parse(localStorage.getItem('user'))
                  let setting_data = JSON.parse(localStorage.getItem('setting-record'))
                  let key_data = setting_data.filter((item) => item.key == 'Content Apps')
                  this.guideline_data = key_data[0]?._id

                  this.activatedRoute.queryParams
                  .subscribe((params: any) => {
                    this.activeTab = params['status'];
                    this.pageNo = +params['page'];
                    if(this.pageNo>0){
                      this.setPage(this.pageNo);
                    }
                    else this.page.pageNumber = this.pageNo?this.pageNo-1:0
                  })
                  this.pageNumberSubscription = this.store.select(state => state.page.pageNumber)
                  .subscribe(pageNumber => {
                    this.page.pageNumber = pageNumber;
                    if(pageNumber !==undefined){
                      this.page.pageNumber = pageNumber ?  pageNumber-1 :0
                    }
                  });
                  if(this.activeTab) this.activeAppTab(this.activeTab,this.pageNo?this.pageNo:1)
                  if(!this.activeTab) this.activeAppTab('Text',this.pageNo?this.pageNo:1)
                  }
  
    ngOnInit(): void {
      this.getAllCourse()
      this.getAllTagCategory()
      this.getContentStatusList()
     this.setAndGetAppByStatus()
    }
    setPage(pageNumber: number) {
      this.store.dispatch(setPageNumber({ pageNumber }));
    }
    // ========================== change App tabs =========================================
    activeAppTab(tab,page) {
      if(page<1){ page =1}
      const activetab = tab;
      if (activetab !== '') {
        this.route.navigate(
          [],
          { relativeTo: this.activatedRoute, queryParams: { status: activetab , page : page },queryParamsHandling: 'merge' }
        );
      }
  }

  // =============================== Programs type Tab ===========================================
    setAndGetAppByStatus() {
    this.activatedRoute.queryParams
      .subscribe((params: any) => {
        this.activeTab = params?.status;
        switch (this.activeTab) {
          
          case 'All':
            this.getAppByStatus(this.activeTab);
            break;
          case 'Video':
            this.columns.push({ name: "payment action", prop: "Payment Actions" })
            this.getAppByStatus(this.activeTab);
            break;
          case 'Text':
            this.getAppByStatus(this.activeTab);
            break
          case 'Image':
            this.getAppByStatus(this.activeTab);
            break;
        }
      })
  }
  
  getAppByStatus(status){
      this.spinner.show(undefined,
        {
          type: 'ball-triangle-path',
          size: 'medium',
          bdColor: 'rgba(0, 0, 0, 0.8)',
          color: '#fff',
          fullScreen: true
        });
      this.apiService.getAppByType(this.page.pageNumber+1,this.limitRef,status,this.selected_tag_cat_id ||'' ).subscribe((res:any)=>{
        this.spinner.hide();
        this.rows=res.data.items
        this.page.totalPages=res.data.totalCount
      })
    }
    pageChangeData(page:any){
      this.spinner.show(undefined,
        {
          type: 'ball-triangle-path',
          size: 'medium',
          bdColor: 'rgba(0, 0, 0, 0.8)',
          color: '#fff',
          fullScreen: true
        });
      this.route.navigate([], {
        relativeTo: this.activatedRoute,
        queryParams: { page: page.offset +1 },
        queryParamsHandling: 'merge' // keep existing query params
      });
      this.apiService.getAppByType(page.offset +1,this.limitRef,this.activeTab,this.selected_tag_cat_id ||'').subscribe((res:any)=>{
        this.spinner.hide()
        this.setPage(page.offset +1)
        this.rows=res.data.items
        this.page.totalPages=res.data.totalCount
    
      })
    }
    getTagsFilter(value:any){
      let search=value
      if(search){
        this.apiService.searchApp(this.page.pageNumber+1,this.limitRef,this.activeTab,search).subscribe((res:any)=>{
          this.rows=res?.data?.items
          this.page.totalPages=res?.data?.totalCount

        })
      }
      else{
        this.setAndGetAppByStatus()
      }
    }
    resetFilter(){
      this.inputName.nativeElement.value=''
      this.selected_course_id =null
      this.selected_tag_cat_id = null
      this.setAndGetAppByStatus()
    }
    editTag(id:any){
    }
    deleteApp(id,password){
      if(id){
        this.apiService.deleteApp(id,password).subscribe((res:any)=>{
          if(res.statusCode === 200){
            this.setAndGetAppByStatus()
          }
          else{
            this.toastr.error(res.error)
          } 
          })
      }
      else{
        this.toastr.error('something went wrong !!')
      }
    }
     // ================== Delete Alert ========================
     confirmDelete(id:any) {
      this.app_id=id
      swal.fire({
        title: 'Are you sure?',
        text: "You won't be able to delete this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#2F8BE6',
        cancelButtonColor: '#F55252',
        confirmButtonText: 'Yes, delete it!',
        customClass: {
          confirmButton: 'btn btn-warning',
          cancelButton: 'btn btn-danger ml-1'
        },
        buttonsStyling: false,
      }).then( (result)=> {
        if (result.value) {  
          this.checkWhereTopicAttached(this.app_id)
          // this.deleteApp(this.app_id)      
          // swal.fire({
          //   icon: "success",
          //   title: 'Deleted!',
          //   text: 'app is deleted!.',
          //   customClass: {
          //     confirmButton: 'btn btn-success'
          //   },
          // })
        } else if (result.dismiss === swal.DismissReason.cancel) {
          swal.fire({
            title: 'Cancelled',
            text: 'your app is safe :)',
            icon: 'error',
            customClass: {
              confirmButton: 'btn btn-success'
            },
          })
        }
      });
    }
    
    addApp(data) {
      this.appType = data.toLowerCase()
      this.selectedApp=null
    }
    editApp(app) {
      this.selectedApp = app
      this.appType=null
    }
    closeModel(): void {
      this.refreshData.emit()
      this.setAndGetAppByStatus()
    }
     openModal(content,data){
      this.connected_courses=data
      const modalRef = this.modalService.open(content);
      modalRef.result.then((result) => {
          // console.log(`Modal closed with result: ${result}`);
        }, (reason) => {
          // console.log(`Modal dismissed with reason: ${reason}`);
        });
  }
  openDynamicModal(key_id:string) {
    const modalOptions: NgbModalOptions = {
      size: 'lg', // 'sm', 'lg', or 'xl'
      backdrop: 'static',
    };
    const modalRef = this.modalService.open(DynamicDetailComponent,modalOptions);
    modalRef.componentInstance.key_id = key_id;
  }
  getContentStatusList() {
    this.apiService.getLeadsStatusList("content-status").subscribe((res: any) => {
      this.status_list = res.data
    })
  }
  
  
  checkWhereTopicAttached(id: any) {
    this.apiService.checkWhereTopicAttach(id).subscribe((res: any) => {
      if (res?.isSuccess) {
        swal.fire({
          icon: "success",
          title: 'App Connected',
          html: `
            <table style="text-align: left;">
              <tr><td><strong>Chapter:</strong></td><td>${res?.data?.Chapter}</td></tr>
              <tr><td><strong>Course:</strong></td><td>${res?.data?.Course}</td></tr>
              <tr><td><strong>Section:</strong></td><td>${res?.data?.Section}</td></tr>
              <tr><td><strong>Topic:</strong></td><td>${res?.data?.Topic}</td></tr>
            </table>
            <p style="margin-top: 10px;"><strong>Are you sure to delete this!</strong></p>
          `,
          showCancelButton: true,
          confirmButtonText: 'Ok',
          cancelButtonText: 'Cancel',
          customClass: {
            confirmButton: 'btn btn-success',
            cancelButton: 'btn btn-danger',
          },
        }).then((result) => {
          if (result.isConfirmed) {
            // Show password prompt
            swal.fire({
              text: "Please Enter Password",
              input: "password",
              inputAttributes: {
                autocapitalize: 'off',
              },
              showCancelButton: true,
              confirmButtonText: 'Submit',
              cancelButtonText: 'Cancel',
              customClass: {
                confirmButton: 'btn btn-success',
                cancelButton: 'btn btn-danger',
              },
            }).then((passwordResult) => {
              if (passwordResult.isConfirmed) {
                const password = passwordResult.value; // Retrieve entered password
                if (password) {
                  // Call the deleteApp function with the provided ID
                  this.deleteApp(id,password);
                } else {
                  swal.fire({
                    icon: 'error',
                    text: 'Password is required!',
                  });
                }
              } else {
                console.log('Password input cancelled');
              }
            });
          } else {
            console.log('Action cancelled');
          }
        });
      } else {
        this.toastr.error(res?.error);
      }
    });
  }
  
  checkConnection(id:any){
    this.apiService.checkWhereTopicAttach(id).subscribe((res: any) => {
      if (res?.isSuccess) {
        swal.fire({
          icon: "success",
          title: 'App Connected',
          html: `
            <table style="text-align: left;">
              <tr><td><strong>Chapter:</strong></td><td>${res?.data?.Chapter}</td></tr>
              <tr><td><strong>Course:</strong></td><td>${res?.data?.Course}</td></tr>
              <tr><td><strong>Section:</strong></td><td>${res?.data?.Section}</td></tr>
              <tr><td><strong>Topic:</strong></td><td>${res?.data?.Topic}</td></tr>
            </table>
          `
        })
      } else {
        this.toastr.error(res?.error);
      }
    });
  }
  getAllTagCategory(){
    this.spinner.show(undefined,
      {
        type: 'ball-triangle-path',
        size: 'medium',
        bdColor: 'rgba(0, 0, 0, 0.8)',
        color: '#fff',
        fullScreen: true
      });
    this.apiService.getTagsList(1, 1000).subscribe((res: any) => {
      this.spinner.hide();
      this.tag_cat_list = res.data.items
    })
  }
  getTagCatId(event){
    this.selected_tag_cat_id 
    this.setAndGetAppByStatus()
  }
  openStatusModal(content,data){
    this.app_id = data._id
    this.selected_status =data.app_status.map(item=>item._id)
    const modalRef = this.modalService.open(content);
    modalRef.result.then((result) => {
        // console.log(`Modal closed with result: ${result}`);
        this.selected_status =null
      }, (reason) => {
        this.selected_status =null

        // console.log(`Modal dismissed with reason: ${reason}`);
      });
  }
  getStatusId(event){
    this.selected_status
  }
  updateStatus() {
    this.spinner.show(undefined,
      {
        type: 'ball-triangle-path',
        size: 'medium',
        bdColor: 'rgba(0, 0, 0, 0.8)',
        color: '#fff',
        fullScreen: true
      });
    let formData= new FormData();
    this.selected_status.forEach((value, index) => {
      formData.append(`app_status[${index}]`, value);
    });
    this.apiService.updateApp(this.app_id, formData).subscribe((res: any) => {
      if (res) {
        this.spinner.hide()
        this.modalService.dismissAll()
        this.toastr.success("status updated successfull!");
        this.setAndGetAppByStatus();
      } else {
        this.toastr.error(res.error);
      }
    });
  }
  getAllCourse(){
    this.spinner.show(undefined,
      {
        type: 'ball-triangle-path',
        size: 'medium',
        bdColor: 'rgba(0, 0, 0, 0.8)',
        color: '#fff',
        fullScreen: true
      });
    this.apiService.getAllCourses(1,1000).subscribe((res:any)=>{
      this.spinner.hide()
      this.courses=res.data.items
    })
  }
  getCourseId(event){
    this.selected_course_id
    if(this.selected_course_id){
      this.apiService.getAppByCourse(this.selected_course_id).subscribe((res:any)=>{
        this.spinner.hide()
        this.rows=res.data[0].apps.map(item =>item)
        this.page.totalPages=res.data[0].apps.length
        this.limitRef = 200
      })
    }
  }

  }
  